import Component from 'vue-class-component'

// https://class-component.vuejs.org/guide/additional-hooks.html
Component.registerHooks([
  // 'beforeRouteEnter',
  'beforeRouteLeave',
  // 'beforeRouteUpdate'
])
